import InputAdornment from '@mui/material/InputAdornment';

import { Icon } from '../../../Icon';
import { Box } from '../../../Box';

/**
 * Свойства компонента {@link ClearButton}
 */
interface ClearButtonProps {
  /**
   * Дополнительный CSS-класс.
   */
  className?: string;

  /**
   * Цвет иконки кнопки.
   *
   * @defaultValue `'disabled'`
   */
  color?: 'disabled' | 'error';

  /**
   * Обработчик клика по кнопке.
   */
  onClick: () => void;

  /**
   * Тестовый ID для кнопки.
   */
  testId?: string;
}

/**
 * ClearButton - компонент для отображения кнопки очистки.
 *
 * @public
 * @param className - Дополнительный CSS-класс.
 * @param color - Цвет иконки кнопки.
 * @param onClick - Обработчик клика по кнопке.
 * @param testId - Тестовый ID для кнопки.
 * @returns Возвращает JSX-элемент представляющий компонент ClearButton.
 *
 * @remarks
 *
 * Ссылка на свойства компонента {@link ClearButtonProps}
 */

export const ClearButton = ({
  className = '',
  color = 'disabled',
  onClick,
  testId,
}: ClearButtonProps) => (
  <InputAdornment className={className} position="end" sx={{ height: 0 }}>
    <Box onClick={onClick} testId={testId}>
      <Icon
        name="dismiss_substract"
        color={color === 'disabled' ? 'stroke.secondary' : 'accent.text.error'}
        size="24"
      />
    </Box>
  </InputAdornment>
);
